import { render, staticRenderFns } from "./refWork.vue?vue&type=template&id=5ee9875a&scoped=true"
import script from "./refWork.vue?vue&type=script&lang=js"
export * from "./refWork.vue?vue&type=script&lang=js"
import style0 from "./refWork.vue?vue&type=style&index=0&id=5ee9875a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee9875a",
  null
  
)

export default component.exports